import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetLand } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface GovernmentalFeesProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const GovernmentalFees: React.FC<GovernmentalFeesProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [governmentalFees, set_governmentalFees] = useBudgetLandField<number>(
        propertyGuid,
        (b) => (b.values?.['Setup']?.['Governmental Fees'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Setup': { ...b.values?.['Setup'], 'Governmental Fees': v } } })
    );
    const label = 'Governmental Fees';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(governmentalFees)}
                />
            ) : (
                <MoneyBox
                    id={'governmentalFees'}
                    allowNegative={false}
                    value={governmentalFees}
                    onChange={(value) => set_governmentalFees(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
